declare var netmera: any;
import { Injectable } from '@angular/core';
import { UtilService } from '@service/utils/util.service';
import { AnalyticsUser } from '@model/user/analytics-user';
import { AppLogsService } from '@service/utils/app-logs.service';
import { AppLog } from '@model/database/app-log';
import { AppLogLevel } from '@model/database/app-log-level';

@Injectable({
    providedIn: 'root'
})
export class UserRegistrationService {

    constructor(private appLogsService: AppLogsService) { }

    saveUser(user: AnalyticsUser, operation: string): void {
        const _this = this;
        netmera.push((api) => {
            const netmeraUser = api.getUser();
            if (!netmeraUser) {
                UtilService.logError(['Failed to save Netmera user:', 'api user object not found.']);
                return;
            }

            netmeraUser.setName(user.name);
            netmeraUser.setEmail(user.email); // better use this field for dotted / undotted e-mail case
            netmeraUser.setCustomId(user.customId);
            netmeraUser.save()
                .then(() => {
                    UtilService.logInfo(['Netmera user saved.', JSON.stringify(user)]);
                    const appLog = new AppLog(AppLogLevel.INFO, 'Netmera user saved.' + JSON.stringify(this.maskUserInfo(user)), operation);
                    _this.insertRegistrationLog(appLog);
                })
                .catch((err) => {
                    UtilService.logError(['Failed to save Netmera user:', JSON.stringify(user), 'error:', err]);
                    const appLog = new AppLog(AppLogLevel.INFO, 'Netmera user saved.' + JSON.stringify(this.maskUserInfo(user)), operation);
                    _this.insertRegistrationLog(appLog);
                });
        });
    }

    maskUserInfo(user: AnalyticsUser) : AnalyticsUser {
        return {...user, name: this.maskName(user.name), email: this.maskEmail(user.email)};
    }

    maskName(name): string {
        const _this = this;
        return (name || '').split(' ').map(name => {
            return _this.maskStringWithoutStartEndLetters(name);
        }).join(' ');
    }

    maskEmail(email): string {
        const _this = this;
        return email.replace(/([\w.]+)@([\w.]+)(\.[\w.]+)/g, (m, p1, p2, p3) => {      
            return _this.maskStringWithoutStartEndLetters(p1) + '@' + p2 + p3;
        });
    }

    maskStringWithoutStartEndLetters(str: string): string {
        if ((str || '').trim().length === 0 || str.length < 3) {
            return str || '';
        }
        return str[0] + str.slice(1, -1).replace(/\w/g, '*') + str.slice(-1);
    }

    insertRegistrationLog(appLog: AppLog): void {
        try {
            this.appLogsService.insertLog(appLog);
        } catch (err) {
            UtilService.logError(['Failed to save netmera user registration log:', JSON.stringify(appLog), 'error:', err]);
        }
    }
}
